<template lang="pug">
  div.change-log
    button.button(
      @click="showJournal"
    ) Журнал изменений
    e-modal(
      v-if="hasModalChangeLog"
      @close="hasModalChangeLog = false"
      title="Журнал изменений"
    )
      e-table-inner(
        ref="log"
        :visibleColumns="logVisibleColumns"
        :itemsEndpoint="getEndpoint"
        :showDeleteButton="false"
        :showEditButton="false"
        :showCheckbox="false"
      )
        template(slot="from" slot-scope="props")
          e-journal-json-log(
            :jsonStringOrObject="props.row.from"
            :jsonStringOrObjectPrev="props.row.to"
            :markNulledAsCreated="false"
          )
        template(slot="to" slot-scope="props")
          e-journal-json-log(
            :jsonStringOrObject="props.row.to"
            :jsonStringOrObjectPrev="props.row.from"
          )
</template>

<script>
import { journal } from '@/api/api-endpoints'
const APO_TARIFF = 18

export default {
  name: 'change-log',
  data: () => ({
    hasModalChangeLog: false,
    items: {},
  }),
  computed: {
    logVisibleColumns() {
      return {
        user_name: { label: 'Пользователь' },
        type: { label: 'Вид действия' },
        create_at: { label: 'Дата действия' },
        from: { label: 'Старое значение' },
        to: { label: 'Новое значение' },
      }
    },
  },
  methods: {
    getEndpoint(ctx) {
      if (ctx && ctx.paginateObj && ctx.paginateObj.page) {
        this.$route.query.page = ctx.paginateObj.page
      }
      if (ctx && ctx.paginateObj && ctx.paginateObj['per-page']) {
        this.$route.query['per-page'] = ctx.paginateObj['per-page']
      }

      return {
        url: journal.apo({
          query: {
            module_id: APO_TARIFF,
            entity_id: this.$route.params.id,
            page: this.$route.query.page || 1,
            'per-page': this.$route.query['per-page'] || 20,
          },
        }),
      }
    },
    showJournal() {
      this.hasModalChangeLog = !this.hasModalChangeLog
      this.getJournal()
    },
    async getJournal() {
      this.items = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: journal.apo({
            query: { module_id: APO_TARIFF, entity_id: this.$route.params.id },
          }),
          fromCache: false,
        })
      ).data
    },
  },
}
</script>

<style scoped lang="scss">
.change-log {
  align-self: flex-end;
}
.button {
  width: auto !important;
  margin: 0 !important;
}
</style>
